import { render, staticRenderFns } from "./foo-index.vue?vue&type=template&id=558bd087&scoped=true&"
import script from "./foo-index.vue?vue&type=script&lang=js&"
export * from "./foo-index.vue?vue&type=script&lang=js&"
import style0 from "./foo-index.vue?vue&type=style&index=0&id=558bd087&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558bd087",
  null
  
)

export default component.exports